module.exports = __webpack_public_path__ + "img/logoWhite.dee835e5.svg";